<template>
  <template v-if="meshEmbossingColors.length > 0">
    <button-card-config
      v-for="color in meshEmbossingColors"
      :key="color.name"
      :title="$t(`views.colors.${color.name}`) ?? color.name"
      @click="emitMeshEmbossingColorSelected(color)"
      class="card-custom"
      :class="{ active: selectedEngravingColor && selectedEngravingColor.name === color.name }"
    >
      <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
    </button-card-config>
  </template>
  <!--     <template v-if="meshTextureColors.length > 0">
    <button-card-config
    v-for="color in meshTextureColors"
    :key="color.name"
    :title="$t(`views.colors.${color.name}`) ?? color.name"
    @click="emitMeshTextureColorSelected(color)"
    class="card-custom"
    :class="{active:selectedColor && selectedColor.name === color.name}" 
    >
    <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
</button-card-config>
</template> -->
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator';
import { RGB2 } from '@/types/api/Utility/RGB2';
import ButtonCardConfig from '../layout/ButtonCardConfig.vue';

@Component({
  components: {
    ButtonCardConfig,
  },
  emits: ['meshEmbossingColorSelected', 'meshTextureColorSelected'],
})
@Component
export default class MeshDesignColorSelector extends Vue {
  // Props
  @Prop({ default: null }) selectedProductName!: string | null;
  @Prop({ required: true }) selectedEngravingColor!: RGB2;
  @Prop({ required: true }) selectedColor!: RGB2;
  @Prop({ required: true }) selectedEngraving!: number;
  @Prop({ default: null }) selectedMeshTextureColor!: RGB2;
  @Prop({ required: true }) meshEmbossingColors!: RGB2[];
  @Prop({ required: true }) meshColors!: RGB2[];
  @Prop({ required: true }) meshTextureColors!: RGB2[];

  emitMeshEmbossingColorSelected(color: RGB2) {
    this.$emit('meshEmbossingColorSelected', color);
    localStorage.setItem('orderColor', color.name);
  }

  emitMeshTextureColorSelected(color: RGB2) {
    this.$emit('meshTextureColorSelected', color);
    localStorage.setItem('orderColor', color.name);
  }
}
</script>

<style lang="scss">
.scroll-wrapper::-webkit-scrollbar {
  height: 8px;
}
.scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
.scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.card-custom {
  width: 130px !important;
  height: 130px !important;
  cursor: pointer;
}

.card {
  border-color: #1d1e19 !important;
  border-width: 2px !important;
  transition: all 0.1s ease-in-out;
}

.card.active {
  border-color: #ac0c0c !important;
  border-width: 4px !important;
}

.card:hover {
  transform: scale(1.03);
}

.img {
  height: 9rem;
  width: 9rem;
}

.rounded-circle {
  height: 48px !important;
  width: 48px !important;
}
</style>
